import React, { useContext } from 'react'
import { makeStyles, withStyles, useTheme } from '@material-ui/styles'
import {
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent,
  useMediaQuery,
  Box,
  CircularProgress,
  IconButton,
  Typography,
} from '@material-ui/core'
import { isFunction } from 'lodash'
import CloseIcon from '@material-ui/icons/Close'

// store
import { Context } from '../store'

import { useCookies } from "react-cookie";
import acceptLanguageParser from "accept-language-parser";

// styles
const useStyles = makeStyles({
  iframeWrapper: {
    margin: '-20px -20px 0',
    height: '100%',
    minHeight: 600,
    position: 'relative',
    zIndex: 5,

    '& iframe': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
    },
  },
  iframeLoading: {
    position: 'absolute',
    top: '20%',
    left: 0,
    width: '100%',
    zIndex: 4,
  },
})

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    minHeight: 10,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
})

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
})

const WorkoutModal = ({ open, onClose }) => {
  const classes = useStyles()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const { globalState } = useContext(Context)
  const clubId = globalState.clubData.id

  const handleClose = () => {
    if (isFunction(onClose)) onClose()
  }

  const [cookies, setCookie] = useCookies(["locale"]);

  const getLocale = () => {
    const acceptLanguageHeader = navigator.languages.join(", ");
    const userLanguages = acceptLanguageParser.parse(acceptLanguageHeader);
  
    // If the user has a preferred locale in a cookie, use it
    const preferredLocale = cookies.locale;

    return preferredLocale ? preferredLocale : userLanguages[0] ? userLanguages[0].code : 'en';
  };


  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
      ></DialogTitle>
      <DialogContent>
        <div className={classes.iframeWrapper}>
          <iframe
            src={`${process.env.REACT_APP_SITE_URL}${getLocale() === 'en' ? '': '/'+getLocale()}/components/book-a-workout?id=${clubId}`}
            frameBorder="0"
            title="book a workout"
          ></iframe>
        </div>
        <div className={classes.iframeLoading}>
          <Box textAlign="center" padding={5}>
            <CircularProgress />
          </Box>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default WorkoutModal
